import { render } from "./SidebarBlog.vue?vue&type=template&id=edbe0798&scoped=true"
import script from "./SidebarBlog.vue?vue&type=script&lang=js"
export * from "./SidebarBlog.vue?vue&type=script&lang=js"

import "./SidebarBlog.vue?vue&type=style&index=0&id=edbe0798&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-edbe0798"]])

export default __exports__